import { LocaleEnum, getLocaleLanguage } from '@systemeio/ui'
import { type TFunctionType } from '@systemeio/util'

export const getLocaleSelectOptions = (tUi: TFunctionType): { id: LocaleEnum; caption: string }[] =>
  Object.values(LocaleEnum).map(locale => ({
    id: locale,
    caption: getLocaleLanguage(locale, tUi),
  }))

// export const getFullySupportedLocaleSelectOptions = (
//   t: TLocoType,
// ): { id: FullySupportedLocaleEnum | undefined; caption: string }[] =>
//   Object.values(FullySupportedLocaleEnum).map(locale => ({
//     id: locale,
//     caption: t(fullySupportedLocaleLanguages[locale]),
//   }))
